export default __webpack_public_path__ + "static/media/item-detail.14d6dbc1.jpg";